import { useState, useEffect } from 'react';
import { Helpers } from '../../../../../../core/src/helpers';

import EtrAPIClient from '../../../../../../core/src/etr-wcs-api-client';

/**
 * memoize by calcodeId to avoid multiple api calls for the same calcodeId
 */
const fetchOffers = Helpers.memoize(async calcodeId => {
    const specialOffersDetails = await EtrAPIClient.product.getOffers(calcodeId).then(resp => {
        const { specialOffersDetails } = resp || {};
        const [offer] = specialOffersDetails || [];
        return offer;
    });
    return specialOffersDetails;
});

export default offer => {
    const [offerDetails, setOffers] = useState({});
    const { calcodeId } = offer;
    useEffect(() => {
        if (calcodeId) {
            const fetchData = async () => {
                const data = await fetchOffers(calcodeId);
                setOffers(data);
            };

            fetchData();
        }
    }, [calcodeId]);
    return offerDetails;
};
